{
  "MFA_SETTINGS": {
    "TITLE": "雙重驗證",
    "SUBTITLE": "透過 TOTP 驗證機制保護您的帳號，防止未經授權的存取。這為您的帳號增添了一層額外的安全防護。",
    "DESCRIPTION": "使用一次性時間密碼 (TOTP) 為您的帳號增加額外的安全防護",
    "STATUS_TITLE": "驗證狀態",
    "STATUS_DESCRIPTION": "管理您的雙重驗證設定及備用還原碼",
    "ENABLED": "已啟用",
    "DISABLED": "已停用",
    "STATUS_ENABLED": "雙重驗證已啟用",
    "STATUS_ENABLED_DESC": "您的帳號已受到額外安全層的保護",
    "ENABLE_BUTTON": "啟用雙重驗證",
    "ENHANCE_SECURITY": "加強帳號安全性",
    "ENHANCE_SECURITY_DESC": "雙重驗證透過在密碼之外要求驗證器應用程式提供驗證碼，為帳號增加額外的安全防護。",
    "SETUP": {
      "STEP_NUMBER_1": "1",
      "STEP_NUMBER_2": "2",
      "STEP1_TITLE": "使用驗證器應用程式掃描 QR Code",
      "STEP1_DESCRIPTION": "請使用 Google Authenticator、Authy 或任何相容 TOTP 的應用程式",
      "LOADING_QR": "載入中...",
      "MANUAL_ENTRY": "無法掃描？請手動輸入代碼",
      "SECRET_KEY": "密鑰",
      "COPY": "複製",
      "ENTER_CODE": "請輸入驗證器應用程式中的 6 位數驗證碼",
      "ENTER_CODE_PLACEHOLDER": "000000",
      "VERIFY_BUTTON": "驗證並繼續",
      "CANCEL": "取消",
      "ERROR_STARTING": "MFA 未啟用，請聯繫管理員。",
      "INVALID_CODE": "驗證碼無效",
      "SECRET_COPIED": "密鑰已複製到剪貼簿",
      "SUCCESS": "雙重驗證已成功啟用"
    },
    "BACKUP": {
      "TITLE": "儲存您的備用碼",
      "DESCRIPTION": "請妥善保管這些備用碼。當您無法使用驗證器時，每組備用碼可使用一次",
      "IMPORTANT": "重要：",
      "IMPORTANT_NOTE": "請將這些備用碼存放在安全的地方，您將無法再次查看。",
      "DOWNLOAD": "下載",
      "COPY_ALL": "全部複製",
      "CONFIRM": "我已將備用碼存放在安全的地方，並了解將無法再次查看",
      "COMPLETE_SETUP": "完成設定",
      "CODES_COPIED": "備用碼已複製到剪貼簿"
    },
    "MANAGEMENT": {
      "BACKUP_CODES": "備用碼",
      "BACKUP_CODES_DESC": "若您已遺失或用完備用碼，請重新產生新的備用碼",
      "REGENERATE": "重新產生備用碼",
      "DISABLE_MFA": "停用 2FA",
      "DISABLE_MFA_DESC": "移除帳號的雙重驗證",
      "DISABLE_BUTTON": "停用雙重驗證"
    },
    "DISABLE": {
      "TITLE": "停用雙重驗證",
      "DESCRIPTION": "您需要輸入密碼和驗證碼才能停用雙重驗證。",
      "PASSWORD": "密碼",
      "OTP_CODE": "驗證碼",
      "OTP_CODE_PLACEHOLDER": "000000",
      "BACKUP_CODE": "備用碼",
      "BACKUP_CODE_PLACEHOLDER": "請輸入您的其中一組備用碼",
      "USE_BACKUP_CODE": "Lost access to your authenticator? Use a backup code instead",
      "USE_OTP_CODE": "Use a verification code from your authenticator app",
      "CONFIRM": "停用 2FA",
      "CANCEL": "取消",
      "SUCCESS": "雙重驗證已停用",
      "ERROR": "停用 MFA 失敗，請確認您的帳號憑證。"
    },
    "REGENERATE": {
      "TITLE": "重新產生備用碼",
      "DESCRIPTION": "此操作將使現有的備用碼失效，並產生新的備用碼。請輸入驗證碼以繼續。",
      "OTP_CODE": "驗證碼",
      "OTP_CODE_PLACEHOLDER": "000000",
      "CONFIRM": "產生新備用碼",
      "CANCEL": "取消",
      "NEW_CODES_TITLE": "已產生新的備用碼",
      "NEW_CODES_DESC": "您先前的備用碼已失效。請將這些新備用碼存放在安全的地方。",
      "CODES_IMPORTANT": "重要：",
      "CODES_IMPORTANT_NOTE": "每組備用碼僅能使用一次，請在關閉此視窗前妥善儲存。",
      "DOWNLOAD_CODES": "下載備用碼",
      "COPY_ALL_CODES": "複製全部備用碼",
      "CODES_SAVED": "我已儲存備用碼",
      "SUCCESS": "已產生新的備用碼",
      "ERROR": "重新產生備用碼失敗"
    }
  },
  "MFA_VERIFICATION": {
    "TITLE": "雙重驗證",
    "DESCRIPTION": "請輸入驗證碼以繼續",
    "AUTHENTICATOR_APP": "驗證器應用程式",
    "BACKUP_CODE": "備用碼",
    "ENTER_OTP_CODE": "請輸入驗證器應用程式中的 6 位數驗證碼",
    "ENTER_BACKUP_CODE": "請輸入您的其中一組備用碼",
    "BACKUP_CODE_PLACEHOLDER": "000000",
    "VERIFY_BUTTON": "驗證",
    "TRY_ANOTHER_METHOD": "嘗試其他驗證方式",
    "CANCEL_LOGIN": "取消並返回登入頁面",
    "HELP_TEXT": "登入時遇到問題？",
    "LEARN_MORE": "進一步了解 2FA",
    "HELP_MODAL": {
      "TITLE": "雙重驗證說明",
      "AUTHENTICATOR_TITLE": "使用驗證器應用程式",
      "AUTHENTICATOR_DESC": "開啟您的驗證器應用程式（Google Authenticator、Authy 等），並輸入您帳號所顯示的 6 位數驗證碼。",
      "BACKUP_TITLE": "使用備用碼",
      "BACKUP_DESC": "若您無法使用驗證器應用程式，可以使用設定 2FA 時所儲存的備用碼。每組備用碼僅能使用一次。",
      "CONTACT_TITLE": "需要更多協助？",
      "CONTACT_DESC_CLOUD": "若您無法使用驗證器應用程式及備用碼，請聯繫 Chatwoot 支援團隊以取得協助。",
      "CONTACT_DESC_SELF_HOSTED": "若您無法使用驗證器應用程式及備用碼，請聯繫您的管理員以取得協助。"
    },
    "VERIFICATION_FAILED": "驗證失敗，請再試一次。"
  }
}
